import React, {
  // useRef,
  useState, useEffect
}
  from 'react';
  import { AutoCenter,SpinLoading } from 'antd-mobile'
import { request } from '@/utils'

import { useSearchParams, useNavigate } from 'react-router-dom';
import './index.scss'
// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/c/font_4335219_nhipwl2o8u8.js',
// });


const TOKENKEY = 'aef_token'


const M1 = () => {
  const navigate = useNavigate()
  const [urlp] = useSearchParams()
  const [ticks, setTicks] = useState([]);

  useEffect(() => {
    async function getau() {
      const res = await request.post('/v2/a_resqr_aef', { unitcode: urlp.get('q') })
      res.return_code === "success" && localStorage.setItem(TOKENKEY, JSON.stringify(res))
      res.return_code === "success" && navigate('/RLF')

      setTicks(res.ticks)

      console.log(res)
    }
    getau()
  }, [urlp, ticks,navigate])


  ///请求 返回json  写入

  return <><AutoCenter><SpinLoading color='primary' style={{ '--size': '59px',marginTop:"200px" }}/></AutoCenter>
  
  </>
}

export default M1;